export const BP_SMALL_DOWN = 'max-width: 599px'
export const BP_SMALL_UP = 'min-width: 600px'

export const BP_MEDIUM_DOWN = 'max-width: 959px'
export const BP_MEDIUM_UP = 'min-width: 960px'

export const BP_LARGE_DOWN = 'max-width: 1279px'
export const BP_LARGE_UP = 'min-width: 1280px'

export const BP_XL_LARGE_DOWN = 'max-width: 1919px'
export const BP_XL_LARGE_UP = 'min-width: 1920px'
